import {
    httpCreatePlannedAccesses,
    HttpCreatePlannedAccessesOptions
} from '@/features/planned-accesses/http/plannedAccesses.http'
import {ProjectPlannedAccess} from '@/features/planned-accesses/types'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStorePlannedAccesses = (
    projectId: string,
    options?: UseMutationOptions<
        ProjectPlannedAccess,
        AxiosError<ErrorResponseData>,
        HttpCreatePlannedAccessesOptions['payload']
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_PLANNED_ACCESSES, projectId],
        mutationFn: (payload: HttpCreatePlannedAccessesOptions['payload']) =>
            httpCreatePlannedAccesses({urlParams: {projectId}, payload}),
        onSuccess: (response, variables, context) => {
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.ACCESSES, projectId]})
            void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PROJECT_VALIDATORS, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES, projectId]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT_VALIDATORS, projectId]})

            options?.onSuccess?.(response, variables, context)
        }
    })
}
